import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { Root, classes } from './utils';
import AgGrid from '../../common-components/common-ag-grid/AgGrid';
import activityHistoryColumnDef from './activityHistoryColumnDef';
import { getGridFilterSortStatus } from '../../../../services/allInvoiceApi';
import ROLES from '../../../../constants/roles';
import { getLocalStorageItem } from '../../../../services/localStorageUtils';
import { activityHistory } from '../../../../services/userApi';

const ActivityHistory = () => {
  const loginRole = getLocalStorageItem('role');

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const organizationId = searchParams.get('organizationId');
  const [gridSettingData, setGridSettingData] = useState({});

  useEffect(() => {
    const getFilterSortData = async () => {
      try {
        const response = await getGridFilterSortStatus('activity-history');
        setGridSettingData(response);
      } catch (err) {
        return err;
      }
    };

    getFilterSortData();
  }, []);

  const getActivityHistoryRowData = async (
    sortModel,
    searchValues,
    filterModel,
    filterValue,
    data,
    page,
  ) => {
    try {
      const PAGE_LIMIT = 25;
      const query = {};
      if (Object.keys(filterModel).length > 0) {
        Object.keys(filterModel).forEach((key) => {
          if (key === 'timestamp' && filterModel[key]) {
            if (filterModel[key].dateFrom) {
              query.timestamp_from = filterModel[key].dateFrom;
            }
            if (filterModel[key].dateTo) {
              query.timestamp_to = filterModel[key].dateTo;
            }
          } else if (filterModel[key] && filterModel[key].filter) {
            query[key] = filterModel[key].filter;
          }
        });
      }
      if (data && Object.keys(data).length > 0) {
        Object.keys(data).forEach((key) => {
          if (Array.isArray(data[key]) && data[key].length > 0) {
            query[key] = data[key].map((ele) => ele.value);
          } else if (loginRole === ROLES.ADMIN) {
            query[key] = ['ADMIN', 'MANAGER', 'MEMBER'];
          } else if (loginRole === ROLES.SUPER_ADMIN) {
            query[key] = ['SUPER_ADMIN', 'SUPER_MANAGER'];
          } else if (loginRole === ROLES.SUPER_MANAGER) {
            query[key] = ['SUPER_MANAGER'];
          }
        });
      }
      const payload = {
        sortType:
          Array.isArray(sortModel) && sortModel.length > 0
            ? sortModel[0].sort
            : '',
        sortOn:
          Array.isArray(sortModel) && sortModel.length > 0
            ? sortModel[0].colId
            : '',
        query,
        page,
        limit: PAGE_LIMIT,
      };
      const result = await activityHistory(payload);
      return result;
    } catch (error) {
      return error;
    }
  };

  return (
    <Root className={classes.root}>
      <Box className={classes.MainBox}>
        <AgGrid
          className={classes.accuracyDetailsAgGridStyle}
          TitleHeader="Activity History"
          columnData={activityHistoryColumnDef}
          getRowData={getActivityHistoryRowData}
          gridSettingData={gridSettingData}
          functionData={organizationId}
          gridKey="activity-history"
          setGridSettingData={setGridSettingData}
        />
      </Box>
    </Root>
  );
};

export default ActivityHistory;
